import React, { useEffect, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { connect } from "react-redux";
import { Auth } from "aws-amplify";
import { compose } from "redux";
import _ from "lodash";

import signinLogo from "assets/images/signin/logo.png";
import banner from "assets/images/signin/banner.png";
import emailLogo from "assets/images/signin/email.png";
import Button from "shared/components/Button";
import Alert from "shared/components/alert";
import signUpOrSignInWithMicrosoftToken from "shared/components/msal";
import * as loaderAction from "redux/loader/action";
import * as signinAction from "redux/signin/action";
import SignInWays from "./components/SignInWays";
import InputContainer from "./components/InputContainer";

const SignIn = (props) => {
  const { instance, accounts } = useMsal();
  const history = useHistory();

  const signin_params = _.get(
    props,
    "paramsReducer.paramsObj.mobile_website.signin"
  );
  const password_reset_details = _.get(
    props,
    "signinReducer.password_reset_details"
  );
  const { signUp } = password_reset_details;
  const setIsLoading = _.get(props, "setIsLoading");
  const set_password_reset_details = _.get(props, "set_password_reset_details");
  const [signUpWithEmail, setSignUpWithEmail] = useState(false);
  const [userDetails, setUserDetails] = useState({
    name: "",
    email: "",
    password: ""
  });

  useEffect(() => {
    if (accounts.length > 0) {
      const request = {
        scopes: ["User.Read"],
        account: accounts[0]
      };
      instance.acquireTokenSilent(request).then((response) => {
        setIsLoading(true);
        signUpOrSignInWithMicrosoftToken(response);
      });
    }
  }, [instance, accounts]);

  const handleSignInChange = () => {
    set_password_reset_details({ ...password_reset_details, signUp: !signUp });
    setSignUpWithEmail(false);
  };

  const handleEmailSignUp = () => {
    setSignUpWithEmail(true);
  };
  const handleResetPassword = () => {
    console.log("hfjheufhuj");
    history.push("/password_reset");
  };
  const handleBackClick = () => {
    setSignUpWithEmail(false);
  };

  const handleInputChange = (value, name) => {
    name === "name"
      ? setUserDetails((prev) => ({ ...prev, name: value }))
      : name === "email"
      ? setUserDetails((prev) => ({ ...prev, email: value }))
      : setUserDetails((prev) => ({ ...prev, password: value }));
  };

  const onEmailSignUp = () => {
    if (
      userDetails.name !== "" &&
      userDetails.email !== "" &&
      userDetails.password !== ""
    ) {
      setIsLoading(true);
      Auth.signUp({
        username: userDetails.email,
        password: userDetails.password,
        attributes: {
          email: userDetails.email,
          name: userDetails.name
        }
      })
        .then((data) => {
          Alert(200, "You have successfully registered");
          if (data) {
            Auth.signIn(userDetails.email, userDetails.password)
              .then((data) => {})
              .catch((error) => {
                setIsLoading(false);
                Alert(400, error.message);
              });
          }
        })
        .catch((error) => {
          setIsLoading(false);
          Alert(400, error.message);
        });
    } else {
      Alert(400, "Incorrect name, email or password");
    }
  };

  const onEmailSignIn = () => {
    if (userDetails.email !== "" && userDetails.password !== "") {
      setIsLoading(true);
      Auth.signIn(userDetails.email, userDetails.password)
        .then((data) => {
          Alert(200, "You have successfully signed in");
        })
        .catch((error) => {
          setIsLoading(false);
          Alert(400, error.message);
        });
    } else {
      Alert(400, "Incorrect email or password");
    }
  };
  return (
    <div className="signin-container">
      <img alt="" src={banner} className="signin-banner" />
      <div className="top-container">
        <img alt="" src={signinLogo} className="signin-logo" />
        <h2 className="auth-heading">{signUp ? "Sign Up" : "Log In"}</h2>
        <p className="email-txt d-non">Welcome back, sign in to continue.</p>
        {/* {signUp && (
          <p className="signup-desc email-txt">
            Get started building team culture today!
          </p>
        )} */}
        {!signUpWithEmail && (
          <div className="sign-with-email">
            <SignInWays
              handleEmailSignUp={handleEmailSignUp}
              instance={instance}
            />
            {/*   <span
              className={`show-more ${showMore ? "active" : ""}`}
              onClick={() => setShowMore((prev) => !prev)}
            >
              {showMore ? show_less : show_more}
            </span> */}
          </div>
        )}
        {/*  {signUpWithEmail && signUp && (
          <div className="use-email-btn back" onClick={handleBackClick}>
            <h2 className="text">Back</h2>
          </div>
        )} */}
        {/*  {!showMore && (
          <div className="or-div">
            <div className="green-line" />
            <span className="or-text">OR</span>
            <div className="green-line" />
          </div>
        )} */}

        {/*  {!signUpWithEmail && !showMore && signUp && (
          <div className="use-email-btn" onClick={handleEmailSignUp}>
            <img alt="" src={emailLogo} className="logo" />
            <h2 className="text">Use Email</h2>
          </div>
        )} */}
        {signUpWithEmail && (
          <>
            <InputContainer
              signUp={signUp}
              user={userDetails}
              onInputChange={handleInputChange}
            />
            <Button
              class_name="signup-btn"
              text={signUp ? "Sign up With Email" : "Log In With Email"}
              onPress={signUp ? onEmailSignUp : onEmailSignIn}
            />
          </>
        )}
        {/*  {!signUp && !showMore && (
          <>
            <InputContainer
              signUp={signUp}
              user={userDetails}
              onInputChange={handleInputChange}
            />
            <span
              className="signin-forgot-password"
              onClick={() => props.history.push("/password_reset")}
            >
              Forgot Password?
            </span>
            <Button text="Log In With Email" onPress={onEmailSignIn} />
          </>
        )} */}
        <div className="account-div">
          {signUpWithEmail ? (
            <>
              <p className="res-txt">
                Need to reset your password?{" "}
                <span onClick={handleResetPassword}>Reset here</span>
              </p>
            </>
          ) : (
            <>
              <span className="account-text-1">
                {signUp ? "Already have an account? " : "Need an account "}
              </span>
              <span onClick={handleSignInChange} className="account-text-2">
                {signUp ? "Log In" : "Sign Up"}
              </span>
            </>
          )}
        </div>
      </div>
      <div className="text-center" style={{ paddingBottom: "14px" }}>
        <p className="heylime-bottom-text">Back to Home </p>
        <p className="heylime-bottom-text">
          © 2023 heyLIME. All rights reserved.
        </p>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  paramsReducer: state.paramsReducer,
  signinReducer: state.signinReducer
});

const mapDispatchToProps = (dispatch) => ({
  setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
  set_password_reset_details: (data) =>
    dispatch(signinAction.set_password_reset_details(data))
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(SignIn);
